import React, { PropsWithChildren, useEffect } from 'react';
import { useLanguageStore } from './stores/languageStore';
import i18n from './i18n';

const LanguageProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { language } = useLanguageStore();

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  return <>{children}</>;
};

export default LanguageProvider;
